const script = document.currentScript as HTMLScriptElement;
const url = new URL(script.src);
const shopDomain = url.searchParams.get("shop") || "";

export default {
    shopDomain: shopDomain,
    oneIdWidgetEndpoint: process.env.MIX_ONEID_WIDGET_ENDPOINT,
    baseUrl: process.env.MIX_APP_BASE_URL,
    api: {
        url: process.env.MIX_API_BASE_URL,
        timeout: 30000,
    },
    env: process.env.MIX_APP_ENV
};
